import type {
  TransformerEvaluatedAvailableCapacity,
  TransformerEvaluatedLoading,
  TransformerEvaluatedRatedCapacity
} from '@/features/execute-calculation-set/overmind/calculation/derived-state/loadFlowSummary';

import type { Percent } from '../../../../../domain/Percent';
import type { AttentionStatusType } from '../../../../AttentionStatus';
import type { ForMessaging } from '../../../../AttentionStatusRepository';
import type { ForRuleProviding } from '../../../../RulesProvider';
import type { ForPowerTransformerEvaluation } from '../../../gridElements/powerTransformer/forPowerTransformerEvaluation';
import { AvailableCapacityEvaluation } from './propertiesEvaluation/availableCapacityEvaluation';
import { LoadingPercentEvaluation } from './propertiesEvaluation/loadingPercentEvaluation';
import { RatedCapacityEvaluation } from './propertiesEvaluation/ratedCapacityEvaluation';

export class PowerTransformerEvaluationEngine
  implements ForPowerTransformerEvaluation
{
  constructor(private readonly rulesProvider: ForRuleProviding) {}

  evaluateLoadingPercent(
    loading: Percent,
    messenger: ForMessaging<AttentionStatusType>
  ): TransformerEvaluatedLoading {
    const evaluation = new LoadingPercentEvaluation(
      this.rulesProvider
    ).evaluate(loading);
    messenger.send(evaluation.status, evaluation.ruleName);
    return evaluation.toEvaluatedResult();
  }

  evaluateAvailableCapacity(
    availableCapacity: number | undefined | null,
    messenger: ForMessaging<AttentionStatusType>
  ): TransformerEvaluatedAvailableCapacity {
    const evaluation = new AvailableCapacityEvaluation(
      this.rulesProvider
    ).evaluate(availableCapacity);
    messenger.send(evaluation.status, evaluation.ruleName);
    return evaluation.toEvaluatedResult();
  }

  evaluateRatedCapacity(
    ratedCapacity: number | null,
    messenger: ForMessaging<AttentionStatusType>
  ): TransformerEvaluatedRatedCapacity {
    const evaluation = new RatedCapacityEvaluation(this.rulesProvider).evaluate(
      ratedCapacity
    );
    messenger.send(evaluation.status, evaluation.ruleName);
    return evaluation.toEvaluatedResult();
  }
}
